export const uMembers = "u-members";
export const uCoordinator = "u-coordinator";
export const uDate = "u-date";
export const uMeal = "u-meal";
export const uGlucose = "u-glucose";
export const uTemperature = "u-temperature";
export const uWeight = "u-weight";
export const uBreathing = "u-breathing";
export const uNote = "u-note";
export const uOxygenSaturation = "u-oxygen-saturation";
export const uLow = "u-low";
export const uHigh = "u-high";
export const uSystolic = "u-systolic";
export const uDiastolic = "u-diastolic";
export const uPulse = "u-pulse";
export const uStatus = "u-status";
export const uAbsoluteThreshold = "u-absolute-threshold";
export const uModerateThreshold = "u-moderate-threshold";
export const sThresholdText = "s-threshold-text";
export const uHighThreshold = "u-high-threshold";
export const uActivity = "u-activity";
export const uSleep = "u-sleep";
